"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForMainMenuUpdates = void 0;
const listenForMainMenuCharacterCustomizeUpdates_1 = require("./listenForMainMenuCharacterCustomizeUpdates");
const listenForMainMenuCharacterSelectUpdates_1 = require("./listenForMainMenuCharacterSelectUpdates");
const listenForMainMenuUpdates = () => {
    (0, listenForMainMenuCharacterSelectUpdates_1.listenForMainMenuCharacterSelectUpdates)();
    (0, listenForMainMenuCharacterCustomizeUpdates_1.listenForMainMenuCharacterCustomizeUpdates)();
};
exports.listenForMainMenuUpdates = listenForMainMenuUpdates;
